export default "__VITE_ASSET__970cb06a__"